import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { Tax } from '@webapp/platform/finance/entities/Tax'
import { taxRepository } from '../../data-access/repositories/TaxRepository'

export const useTaxSelect = ({ defaultTaxId }: { defaultTaxId?: number }) => {
  const { data, isFetching } = useQuery({
    queryKey: ['selects', 'taxes'],
    queryFn: () => {
      return taxRepository.getTaxes({ pageSize: 999 })
    },
    cacheTime: Infinity,
  })

  const taxes = useMemo(() => data?.data.map((t) => new Tax(t)) || [], [data])

  const defaultValue = useMemo(
    () => data?.data.find((t) => t.id === defaultTaxId) || null,
    [data, defaultTaxId]
  )

  return {
    data: { defaultValue, taxes },
    states: { isFetching },
  }
}
